import React, { useEffect, useState } from "react";
import { db } from "../../api";
import {
  collection,
  onSnapshot,
  addDoc,
  deleteDoc,
  doc,
} from "../../api";

export default function CategoryManagement() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name: "",
    description: "",
    requiresSize: true,
    sizeType: "text", // "text" or "number"
    defaultFields: ["quantity", "condition"]
  });

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "equipment_categories"), (snapshot) => {
      const categoryList = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCategories(categoryList);
    });
    return () => unsub();
  }, []);

  const handleCreateCategory = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "equipment_categories"), newCategory);
      setNewCategory({
        name: "",
        description: "",
        requiresSize: true,
        sizeType: "text",
        defaultFields: ["quantity", "condition"]
      });
    } catch (err) {
      console.error(err);
    }
  };

  const handleDeleteCategory = async (categoryId) => {
    try {
      const docRef = doc(db, "equipment_categories", categoryId);
      await deleteDoc(docRef);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="flex flex-col space-y-8">
      <div>
        <h4 className="text-burgundy text-lg font-medium mb-4">
          Equipment Categories
        </h4>
        {categories.length === 0 && <p className="text-navy">No categories found.</p>}
        {categories.map((category) => (
          <div
            key={category.id}
            className="bg-white border border-gray-300 rounded shadow p-4 mb-4"
          >
            <p className="mb-1">
              <strong>Name:</strong> {category.name}
            </p>
            <p className="mb-1">
              <strong>Description:</strong> {category.description}
            </p>
            <p className="mb-1">
              <strong>Requires Size:</strong> {category.requiresSize ? "Yes" : "No"}
            </p>
            <p className="mb-2">
              <strong>Size Type:</strong> {category.sizeType}
            </p>
            <button
              onClick={() => handleDeleteCategory(category.id)}
              className="bg-burgundy text-white py-1 px-3 rounded hover:bg-opacity-90 transition"
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      <div>
        <h4 className="text-burgundy text-lg font-medium mb-4">
          Add New Category
        </h4>
        <form
          onSubmit={handleCreateCategory}
          className="bg-white border border-gray-300 rounded shadow p-4 space-y-4"
        >
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">Category Name:</label>
            <input
              type="text"
              value={newCategory.name}
              onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
              required
              placeholder="e.g., Power Tools, Vehicles, Sporting Equipment"
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
            />
          </div>
          <div className="flex flex-col">
            <label className="text-sm font-medium text-navy">Description:</label>
            <textarea
              value={newCategory.description}
              onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
              placeholder="Brief description of this equipment category"
              className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
              rows="2"
            />
          </div>
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="requiresSize"
              checked={newCategory.requiresSize}
              onChange={(e) => setNewCategory({ ...newCategory, requiresSize: e.target.checked })}
              className="text-burgundy"
            />
            <label htmlFor="requiresSize" className="text-sm font-medium text-navy">
              Equipment in this category requires size specification
            </label>
          </div>
          {newCategory.requiresSize && (
            <div className="flex flex-col">
              <label className="text-sm font-medium text-navy">Size Type:</label>
              <select
                value={newCategory.sizeType}
                onChange={(e) => setNewCategory({ ...newCategory, sizeType: e.target.value })}
                className="border border-gray-300 rounded p-2 focus:outline-none focus:border-burgundy"
              >
                <option value="text">Text (S, M, L, XL)</option>
                <option value="number">Number (measurements, lengths)</option>
              </select>
            </div>
          )}
          <button
            type="submit"
            className="bg-navy text-white py-2 px-4 rounded hover:bg-opacity-90 transition"
          >
            Add Category
          </button>
        </form>
      </div>
    </div>
  );
}